import React, { lazy, useState, Suspense } from 'react';

const Container = lazy(() => import('./container'));

export default function Button(props) {
  const [clicked, setClicked] = useState(false);
  const [open, setOpen] = useState();
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    if (!open) setLoading(true);
    setOpen(!open);
    setClicked(true);
  };

  const close = () => setOpen(false);

  return (
    <div className={open ? 'open' : undefined}>
      <div className="btn btn-default add-to-folder-btn" onClick={handleClick}>
        <i className="fa lp-collection-icon fs-16 va--1 mr5"></i>
        <span className="text mr5">
          <i className="fa-solid fa-circle-plus mr5" />
          <span>Add</span>
          <span className="hidden-xs hidden-sm">&nbsp;to Collection</span>
        </span>
        {loading ? (
          <i className="fa-regular fa-circle-notch fa-spin" />
        ) : (
          <span className="caret"></span>
        )}
      </div>
      {clicked && (
        <Suspense fallback={''}>
          <Container
            {...props}
            handleClose={close}
            onLoaded={() => setLoading(false)}
            loading={loading}
            open={open}
          />
        </Suspense>
      )}
    </div>
  );
}
